(function () {
  'use strict';

  var checkoutSelector = '.zd-drawer-checkout';
  var checkoutUrl = '/checkout';

  function convertCheckoutButton(element) {
    if (!element || !element.matches || !element.matches(checkoutSelector)) return;

    if (element.tagName === 'A') {
      element.setAttribute('href', checkoutUrl);
      element.setAttribute('data-zd-direct-checkout', 'true');
      element.removeAttribute('disabled');
      element.removeAttribute('aria-disabled');
      return;
    }

    var link = document.createElement('a');
    var blockedAttributes = ['type', 'form', 'name', 'disabled', 'aria-disabled'];

    Array.prototype.forEach.call(element.attributes, function (attribute) {
      if (blockedAttributes.indexOf(attribute.name) === -1) {
        link.setAttribute(attribute.name, attribute.value);
      }
    });

    link.setAttribute('href', checkoutUrl);
    link.setAttribute('role', 'button');
    link.setAttribute('data-zd-direct-checkout', 'true');
    link.innerHTML = element.innerHTML;
    element.replaceWith(link);
  }

  function upgradeCheckoutButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(checkoutSelector)) {
      convertCheckoutButton(scope);
    }

    Array.prototype.forEach.call(scope.querySelectorAll(checkoutSelector), convertCheckoutButton);
  }

  function initialise() {
    upgradeCheckoutButtons(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          convertCheckoutButton(mutation.target);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) upgradeCheckoutButtons(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest && event.target.closest(checkoutSelector);
    if (!checkout) return;

    event.preventDefault();
    window.location.assign(checkoutUrl);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  window.addEventListener('pageshow', function () {
    upgradeCheckoutButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    upgradeCheckoutButtons(event.target || document);
  });
})();

/* Zenduce mobile header search toggle - start */
(function () {
  'use strict';

  var MOBILE_MAX = 1024;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function getParts() {
    var header = document.querySelector('.zh-header');

    return {
      header: header,
      row: header && header.querySelector('.zh-mobile-search-row'),
      toggle: header && header.querySelector('.zh-main-row > .zh-wrap > .zh-search-wide')
    };
  }

  function setOpen(open) {
    var parts = getParts();
    if (!parts.row || !parts.toggle) return;

    parts.row.classList.toggle('is-open', !!open);
    parts.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    parts.toggle.setAttribute('aria-label', open ? 'Close search' : 'Open search');
  }

  function init() {
    var parts = getParts();
    if (!parts.toggle) return;

    parts.toggle.setAttribute('aria-expanded', parts.row && parts.row.classList.contains('is-open') ? 'true' : 'false');
    parts.toggle.setAttribute('aria-label', parts.row && parts.row.classList.contains('is-open') ? 'Close search' : 'Open search');
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var toggle = target.closest('.zh-header .zh-main-row > .zh-wrap > .zh-search-wide');
    if (!toggle || !isMobile()) return;

    var parts = getParts();
    if (!parts.row) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    setOpen(!parts.row.classList.contains('is-open'));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  window.addEventListener('resize', function () {
    if (!isMobile()) setOpen(false);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', init, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
/* Zenduce mobile header search toggle - end */
